import { render, staticRenderFns } from "./OrderPlaced.vue?vue&type=template&id=0debdf0c&scoped=true"
import script from "./OrderPlaced.vue?vue&type=script&lang=js"
export * from "./OrderPlaced.vue?vue&type=script&lang=js"
import style0 from "./OrderPlaced.vue?vue&type=style&index=0&id=0debdf0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0debdf0c",
  null
  
)

export default component.exports